import styled from "styled-components";
import stylesForm from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js";

export const TitleWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const TitleStyled = styled.h4`
  color: #3c4858;
`;

export const selectDateMenuStyles = () => ({
  ...selectStyles,
  ...stylesForm,
  ...buttonsStyle,
  cardHover: {
    "&:hover": {
      "& $cardHeaderHover": {
        transform: "translate3d(0, -10px, 0)",
      },
    },
  },
  gridNoPadding: {
    padding: "0 !important",
  },
  cardHeader: {
    padding: "10px",
  },
  cardHeaderHover: {
    transition: "all 300ms cubic-bezier(0.34, 1.61, 0.7, 1)",
  },
  cardTitle: {
    margin: "0",
    marginLeft: ".4rem",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",

    fontSize: "1rem",
    display: "inline",
    textDecoration: "none",
  },
  grid: {
    padding: "0 .4rem",
    margin: "0",
    justifyContent: "center",
    width: "100%",
  },
  selectLabel: {
    ...selectStyles.selectLabel,
    color: "#AAAAAA",
    fontSize: "14px",
    marginTop: ".5rem",
    textTransform: "capitalize",
  },
  marginRow: {
    marginTop: ".5rem",
    marginBottom: ".4rem",
  },
  marginLabelInput: {
    marginBottom: ".5rem",
  },
});

// Styles Mui
export const style = () => ({
  ...stylesForm,
  ...selectStyles,
  buttonIcon: {
    margin: "0 !Important",
  },
  thTable: {
    fontSize: ".875rem !important",
    fontWeight: "bold !important",
    color: (props) => (props ? props.color : "#111111"),
  },
});

export const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 2,
  outline: 'none',
  width: '90%',
  maxHeight: '90%',
  overflowY: 'auto',
};